// extracted by mini-css-extract-plugin
export var avatarContainer = "_b0-0";
export var avatarTypingWave = "_b0-i";
export var gray = "_b0-f";
export var green = "_b0-c";
export var icon = "_b0-9";
export var image = "_b0-1";
export var lg = "_b0-6";
export var md = "_b0-5";
export var presenceDot = "_b0-b";
export var red = "_b0-d";
export var sm = "_b0-4";
export var status = "_b0-a";
export var typingDot = "_b0-h";
export var typingPill = "_b0-g";
export var xl = "_b0-7";
export var xs = "_b0-3";
export var xxl = "_b0-8";
export var xxs = "_b0-2";
export var yellow = "_b0-e";